import { ModalContent } from 'components/modal';

export const ContentContainer = ModalContent.withConfig({
  paddingX: {
    base: '6',
    desktop: '15%',
  },
  paddingTop: {
    desktop: '12',
  },
  paddingBottom: {
    desktop: '8',
  },
});
